export const generateRandomColor = () => {
    const colors = ['#727838', '#80644F', '#7D818A'];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    return randomColor;
};
